import { getLoggedInUser, isEuCountry, logUserActivity } from './utils'

window.onload = () => {

    isEuCountry().then((yes) => {
        if (yes) {
            $('#gdpr').css('display', 'block')
        }
    })

    const user = getLoggedInUser()
    if (user) {
        $('#Email').val(user.displayEmail)
    }
    try {
        if (user) {
            logUserActivity('VIEW_CONTACT_US', user.username, user)
        } else {
            logUserActivity('GUEST_VIEW_CONTACT_US')
        }
    } catch (error) {
        console.error('Error in Analytics:', error)
    }

    $('#contact-btn').on('click', ev => {
        ev.preventDefault()
        console.log('submit')

        // Email, Message, Name, Topic-Options
        const formdata = {}
        $('#email-form').serializeArray().forEach(({ name, value }) => {
            formdata[name] = value
        })
        console.log('formdata=%O', formdata)

        $('.w-form-fail').css('display', 'none')

        if(!formdata.Message) {
            alert("Please fill out the message field")
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/contactus-messages`,
            data: JSON.stringify({
                name: formdata.Name,
                email: formdata.Email,
                topic: formdata['Topic-Options'],
                message: formdata.Message,
            }),
            dataType: 'json',
            contentType: 'application/json',
            error: (response) => {
                console.log('failure response: %O', response)
                const code = (response.responseJSON||{}).code
                console.log('failure code=' + code)

                $('.w-form-fail > div').text(`Something went wrong while submitting the form. code=${code || response.status}`)
                $('.w-form-fail').css('display', 'block')
            }
        })
        .done(response => {
            try {
                const user = getLoggedInUser()
                if (user) {
                    logUserActivity('CONTACT_US', user.username, user)
                } else {
                    logUserActivity('GUEST_CONTACT_US')
                }
            } catch (error) {
                console.error('Error in Analytics:', error)
            }
            $('.w-form-done').css('display', 'block')
            $('#contact-btn').css('display', 'none')

        })
    })

}
